
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faq_459gxqa8OfylM6BbGdXqOO7Uvo5j5MDdPu9Z9fQ_IICUMeta } from "/codebuild/output/src2208652229/src/src/pages/faq.vue?macro=true";
import { default as menuxOOYdrmvr4o5LTPKqnFFgMD1fSoh50Z9p3KYOztlTp8Meta } from "/codebuild/output/src2208652229/src/src/pages/menu.vue?macro=true";
import { default as indexGPHinQ_lFxehKq28OsCK1S9_MdNe62h0KomBNQTozwoMeta } from "/codebuild/output/src2208652229/src/src/pages/index.vue?macro=true";
import { default as contactNapoJLm9ps5PralfWVl6zq1X3BhiEZBO62ghQDLSY8QMeta } from "/codebuild/output/src2208652229/src/src/pages/contact.vue?macro=true";
import { default as tutorial7N_45v4iJBLlhI9yBQkZq_45lRMtnBocygJSceE2UjyfKHYMeta } from "/codebuild/output/src2208652229/src/src/pages/tutorial.vue?macro=true";
import { default as agreementoPiVCg3PNtDb7HLKKklA3R9v1fX4_wbak_HeZMMOmI4Meta } from "/codebuild/output/src2208652229/src/src/pages/agreement.vue?macro=true";
import { default as about_45passpAQF0O23xFT_458m0Dp6L66nSQWAND4lC6E_WFt9OPVo0Meta } from "/codebuild/output/src2208652229/src/src/pages/about-pass.vue?macro=true";
import { default as index3es9UlTdZhrhYrfIGJCEc8wLlfzKcz_45yOCjk8bfN7U8Meta } from "/codebuild/output/src2208652229/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93susmDRknJ_453UV2q2qcSxzf8U8wO41p1KRT4f4aCEAgAMeta } from "/codebuild/output/src2208652229/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancevff5sZ0i_457xaQqgEuUd59zDpGVZSuzPvXFYXfS19PGYMeta } from "/codebuild/output/src2208652229/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93VKs_45B2hS4H2AYJrWoLopDcbfYiWmZl4lin0IIqoLMGUMeta } from "/codebuild/output/src2208652229/src/src/pages/notice/[id].vue?macro=true";
import { default as indexNSbSnwc7VIU3MOvqZCTS8q5YUs8XjbKUjrvryTlG4QIMeta } from "/codebuild/output/src2208652229/src/src/pages/coupon/index.vue?macro=true";
import { default as indexXDRcMlCeEblxkRmLQ0kgYPcZqGVPBc9qc3sOJa5IYGMMeta } from "/codebuild/output/src2208652229/src/src/pages/mypage/index.vue?macro=true";
import { default as indexWq0L8JvmGDoGepnM74P9IhPfLY2xh77ZxXPHbBtM7kUMeta } from "/codebuild/output/src2208652229/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93vLAcFs0WfnW_NONRgJ6b9T8hO1tuUbCW5Fo7D6nT9_IMeta } from "/codebuild/output/src2208652229/src/src/pages/parking/[id].vue?macro=true";
import { default as indexKume9Q3AjMrwVHtjViNcK_45a3a9aJoGiDULRtckiIfgsMeta } from "/codebuild/output/src2208652229/src/src/pages/history/index.vue?macro=true";
import { default as indexAr0ZOF8vakbme4QVitMyo7h7dtIXUcaqmL9zhV98CXwMeta } from "/codebuild/output/src2208652229/src/src/pages/monthly/index.vue?macro=true";
import { default as indexRqr4lSzEV7V4RaYHWq7pmBtv9YfQd7Kl9iJ8yQ3ixscMeta } from "/codebuild/output/src2208652229/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexFVhseygk3oFm_vAnzBqgg_45FZgA1i6cgNEyvcicDfDsYMeta } from "/codebuild/output/src2208652229/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavifD1dwsf_gf_29FkEFSRtwDK6v2rwt2z8XVlTKsusA1AMeta } from "/codebuild/output/src2208652229/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit5uxxSp7B37D0ffrTh_45XG_JZTXScvmfENpdHFY5wrWbUMeta } from "/codebuild/output/src2208652229/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementTKpQ7dcc8He79k5QFnbb4LL3CbIojEaMNuK6hPFd5hAMeta } from "/codebuild/output/src2208652229/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexLTqPsYEnUf1tcv8ISImsc3mC9fUVTaVtDbdqHNaysW0Meta } from "/codebuild/output/src2208652229/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dUtKR4LD6dtL7Av6nT6Dz1_sju9e7oRXJeqsygNTqxrsMeta } from "/codebuild/output/src2208652229/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirm5_45GXQ70Go0zIl_45mIcbpKTteg5ItYlaZwO7yygHFwKi8Meta } from "/codebuild/output/src2208652229/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexn5Uk14McyPZAC1Jv0GpOc1zYObXXIehmcYXBrIMPDP8Meta } from "/codebuild/output/src2208652229/src/src/pages/card/create/index.vue?macro=true";
import { default as indexpnAN_WzG3CN0NxJLqaY1elidwaFq1OuHJ8VPyRL2WjEMeta } from "/codebuild/output/src2208652229/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmUHQO2yxL0edHT_45TNf4f9LN1hR621S6NxUCFqKX0MuhMMeta } from "/codebuild/output/src2208652229/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmpvCK2f6MJo0taTqBpowRBuTt7veDhPgMFizFBop60vkMeta } from "/codebuild/output/src2208652229/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete_iYmmtoHpiBXhgoHdlkJ3e8YlkDchWfkHTxsiYlu7TMMeta } from "/codebuild/output/src2208652229/src/src/pages/membership/complete.vue?macro=true";
import { default as registerBXc4ePoMGz1MT2TSCvylfWQOPRc5zhC6SA1xrSOmyT8Meta } from "/codebuild/output/src2208652229/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93cQ46QIsQdh2aKKJ_45_LCbeb21rO2b_45qgE6P_45f7CW9nOEMeta } from "/codebuild/output/src2208652229/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmSidLrh3YRYn_455Yx2i8pNUmMWtEiZOHSYH4BXbnQm9X8Meta } from "/codebuild/output/src2208652229/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93tZXOdrZm2TZZw_IwQNQl_OlEy7mYhVNmpmLjmH4wTOUMeta } from "/codebuild/output/src2208652229/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexvUaK733CXC6bB6tiaZQBbR9LtYJqSfjr8PTssyRjhrMMeta } from "/codebuild/output/src2208652229/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codexUJdMDgHSNp9b3Gxchy0Lr21qDazrbAiaLhzQJj5CAUMeta } from "/codebuild/output/src2208652229/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codekXAurNMFMxNzy_45_d0J_45TWr0WkFpw1Ynf4r_45gjPJ9yREMeta } from "/codebuild/output/src2208652229/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as complete_45tTj1im1SXT1zUHS68wr9MjsEWv283I9cYm0huRWYPMMeta } from "/codebuild/output/src2208652229/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerYIrkkTq63Dn4khV_b8uro3nrT_BiKr767e93TVqNP_45sMeta } from "/codebuild/output/src2208652229/src/src/pages/contact-form/register.vue?macro=true";
import { default as complete9WNP6WLsnSlmToFfI_45_45Exe2TNfvm9muQlKyr_45_45B2mlcMeta } from "/codebuild/output/src2208652229/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexftAJnhZlqKcb2KBwVKfhCUKZOEn9wmByYL9ZZ8mdPYQMeta } from "/codebuild/output/src2208652229/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmTeEmNsSY_q45My6xSo1QErl2K98X3GMzRkjkfNNCfSEMeta } from "/codebuild/output/src2208652229/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completerH6qyalUlEyKHv_hC6sz23uJQ_453m62_zunb3Ae8uAKUMeta } from "/codebuild/output/src2208652229/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexloRbPATN70TAQd6ohcCoxjfsqCKQwPpsGpmv1zmh30gMeta } from "/codebuild/output/src2208652229/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93WTiN1mlMYgXUtZ4QYbaB87z6Hre9PP4dV49n37RXIK8Meta } from "/codebuild/output/src2208652229/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completepXVKLimVqmaeDscSjgldsDW6G82Wdu09j7FCXbc0pOwMeta } from "/codebuild/output/src2208652229/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasvNeEWRQJvKKE_45OHxotV5A4vimf9bgLLT4mae47LIqQYMeta } from "/codebuild/output/src2208652229/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleIjjWItvawMN5Opr3cX6vVNByPUoRTHygqNMABHgu0aYMeta } from "/codebuild/output/src2208652229/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailq5ToYhj3f9De_450gF6V5fCXRICb7Phhk1fOfSrUk_45GlUMeta } from "/codebuild/output/src2208652229/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmqYDQ7V7FaIG5_455EYqApSDuZhsS_wofGmOYWeEuhheFcMeta } from "/codebuild/output/src2208652229/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consent01sejqbl5vayrDS8L7I0k0iAaFjgcpir8MMy0tDyTU8Meta } from "/codebuild/output/src2208652229/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmaO09UcVVl14_45yEHQJHL0u2dCmIiCETcpCwiwThx1ETcMeta } from "/codebuild/output/src2208652229/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedate1xbtp_45hEhHOypCCboa8z5j_eV9PGuxp6DMi2HaohN78Meta } from "/codebuild/output/src2208652229/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completegue9t40io_45_45qnR30lDdb2vXny2_zDWqn58IDBzbyW8sMeta } from "/codebuild/output/src2208652229/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeR17NVyqWhGP41zUUqbi6qiegXlwUDHF_45z6Yteg5V4z4Meta } from "/codebuild/output/src2208652229/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordmpREQI_ZFS_e52_45csIP4gOhH2knKDlQydnV3hVhg4Meta } from "/codebuild/output/src2208652229/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasRlldlcdXjuqo24x0eDPr4qpd6WSf7fZ_T3oAjqCXShkMeta } from "/codebuild/output/src2208652229/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerJ7bGb5WAXH1YHE8UngF3xtt2eJl2INrNvsL4OUEUm3UMeta } from "/codebuild/output/src2208652229/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45code58OrybqgZWal37pTmIF_45guMifJAfuACmx7lWxd10Z0kMeta } from "/codebuild/output/src2208652229/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as index92SVerN4eI77tJG_EkV964VwLrNlBtkpbeKExX8QvFYMeta } from "/codebuild/output/src2208652229/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexNQET283t1IB8eqmfgQLgO1JcDVsB4GemYxg2K2BaJBQMeta } from "/codebuild/output/src2208652229/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index9RASPit0bA4EGtr1gnGtkQBHNMtwPLbnbaPi_xhfxfMMeta } from "/codebuild/output/src2208652229/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexhseda57wexNTia9Bm9b2lTyCYVaksWTz3_2dO0w4Ow8Meta } from "/codebuild/output/src2208652229/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as update_45QeBYpJrgQE0i6M2yLZC4ktBdjkzGIaswdxUpHfoElsMeta } from "/codebuild/output/src2208652229/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as complete44kkHB8h_45ogNTuNG2xxYbsYZdmZiHZQhId0F2MRr9xsMeta } from "/codebuild/output/src2208652229/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmF59ef5WMpX2oK_n5WccVEVSy6zP4uLX4SOb9qKuWWkEMeta } from "/codebuild/output/src2208652229/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexw3Ipn1eD3s1WPU7PO38eUhCDVCHC4JQOY9TmT_9InFcMeta } from "/codebuild/output/src2208652229/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as complete37vbYbXI32kSQdGHI6IbcKCKiJzsIL_SW_HGHQ4fXy0Meta } from "/codebuild/output/src2208652229/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update5MQCboY33KfRbFEuN435xDRnzHLw0zS0TaaJPmJ_451RcMeta } from "/codebuild/output/src2208652229/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexsWVDv_45OFU5eJqFXZwOznJrquWv7aFmbi6Wot1hWhNDAMeta } from "/codebuild/output/src2208652229/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexLVucdtY0oysyGm0DC71uNsF16kqVjNJRkHln1_h0Q9UMeta } from "/codebuild/output/src2208652229/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeEe4KaSoWYxJBwez75e10urT3VQAUrj9vXZugEIozQ8AMeta } from "/codebuild/output/src2208652229/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexRhUzkDalJQJBqXoRWrayX2ogwkyPTASCblUDTaxybUoMeta } from "/codebuild/output/src2208652229/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45coderFpONMxdgVDSKj_837zOQaVuTkktr9JXSt6bW__45HG8QMeta } from "/codebuild/output/src2208652229/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexbdwEQOUbzdFKe1ROfEan2NU_APW5uZeT3rjM_45eApfzoMeta } from "/codebuild/output/src2208652229/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as index2BKFbpylcivdxqCrLEesOZFtvsKxVJFu_gm_IjTgclMMeta } from "/codebuild/output/src2208652229/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indext0duNMbDzwfmgcyg_YNmTzeRTZdLs2WsVvMCGMGpp4cMeta } from "/codebuild/output/src2208652229/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as update_HE6ihNg8ZdZ7vSh7GfXt_457f9RQHhesZEgGcW8LlICcMeta } from "/codebuild/output/src2208652229/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmNb_45AJiqeIVi4q98yP5DcdZwmQbfgcnwIuFkuOLQdsNUMeta } from "/codebuild/output/src2208652229/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuxOOYdrmvr4o5LTPKqnFFgMD1fSoh50Z9p3KYOztlTp8Meta || {},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexGPHinQ_lFxehKq28OsCK1S9_MdNe62h0KomBNQTozwoMeta || {},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexNSbSnwc7VIU3MOvqZCTS8q5YUs8XjbKUjrvryTlG4QIMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src2208652229/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexKume9Q3AjMrwVHtjViNcK_45a3a9aJoGiDULRtckiIfgsMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src2208652229/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexRqr4lSzEV7V4RaYHWq7pmBtv9YfQd7Kl9iJ8yQ3ixscMeta || {},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexFVhseygk3oFm_vAnzBqgg_45FZgA1i6cgNEyvcicDfDsYMeta || {},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexn5Uk14McyPZAC1Jv0GpOc1zYObXXIehmcYXBrIMPDP8Meta || {},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmUHQO2yxL0edHT_45TNf4f9LN1hR621S6NxUCFqKX0MuhMMeta || {},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmpvCK2f6MJo0taTqBpowRBuTt7veDhPgMFizFBop60vkMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src2208652229/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete_iYmmtoHpiBXhgoHdlkJ3e8YlkDchWfkHTxsiYlu7TMMeta || {},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerBXc4ePoMGz1MT2TSCvylfWQOPRc5zhC6SA1xrSOmyT8Meta || {},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmSidLrh3YRYn_455Yx2i8pNUmMWtEiZOHSYH4BXbnQm9X8Meta || {},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codexUJdMDgHSNp9b3Gxchy0Lr21qDazrbAiaLhzQJj5CAUMeta || {},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codekXAurNMFMxNzy_45_d0J_45TWr0WkFpw1Ynf4r_45gjPJ9yREMeta || {},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: complete_45tTj1im1SXT1zUHS68wr9MjsEWv283I9cYm0huRWYPMMeta || {},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerYIrkkTq63Dn4khV_b8uro3nrT_BiKr767e93TVqNP_45sMeta || {},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmTeEmNsSY_q45My6xSo1QErl2K98X3GMzRkjkfNNCfSEMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src2208652229/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completerH6qyalUlEyKHv_hC6sz23uJQ_453m62_zunb3Ae8uAKUMeta || {},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexloRbPATN70TAQd6ohcCoxjfsqCKQwPpsGpmv1zmh30gMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2208652229/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completepXVKLimVqmaeDscSjgldsDW6G82Wdu09j7FCXbc0pOwMeta || {},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleIjjWItvawMN5Opr3cX6vVNByPUoRTHygqNMABHgu0aYMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2208652229/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailq5ToYhj3f9De_450gF6V5fCXRICb7Phhk1fOfSrUk_45GlUMeta || {},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmqYDQ7V7FaIG5_455EYqApSDuZhsS_wofGmOYWeEuhheFcMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2208652229/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consent01sejqbl5vayrDS8L7I0k0iAaFjgcpir8MMy0tDyTU8Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2208652229/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmaO09UcVVl14_45yEHQJHL0u2dCmIiCETcpCwiwThx1ETcMeta || {},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completegue9t40io_45_45qnR30lDdb2vXny2_zDWqn58IDBzbyW8sMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2208652229/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeR17NVyqWhGP41zUUqbi6qiegXlwUDHF_45z6Yteg5V4z4Meta || {},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordmpREQI_ZFS_e52_45csIP4gOhH2knKDlQydnV3hVhg4Meta || {},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerJ7bGb5WAXH1YHE8UngF3xtt2eJl2INrNvsL4OUEUm3UMeta || {},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45code58OrybqgZWal37pTmIF_45guMifJAfuACmx7lWxd10Z0kMeta || {},
    component: () => import("/codebuild/output/src2208652229/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src2208652229/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]